import React from 'react';
import { IconProps } from '.';

const SvgColoredFingerThree = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#EC8A3C'
        d='M10.82 15.09c0 .05-1.01-.36-1.07-1.74-.06-1.38.58-1.88.58-1.88.25-.24.07-.65 1-.51l.35-.61 5.75.04.29.97c.23.12.44.27.63.46.03.02.31.36.4.52-.02-.02-7.56 10.94-7.56 10.94l-7.17-7.69v-1.57l2.86-2.99'
      />
      <path
        fill='#FFD653'
        d='M9.95 14.14c-.09-.22-.16-.49-.17-.82-.03-.75.18-1.18.38-1.42l-.31-9.21s.09-1.43-1.34-1.52c-1.43-.09-1.52 1.34-1.52 1.34l.51 8.7 2.47 2.94-.02-.01ZM5.37 9.66h.12c.76 0 1.37.62 1.37 1.37v2.99c0 .76-.62 1.37-1.37 1.37h-.12c-.76 0-1.37-.62-1.37-1.37v-2.99c0-.76.62-1.37 1.37-1.37Z'
      />
      <path
        fill='#FFD653'
        d='M17.86 1.4c-1.43-.13-1.56 1.29-1.56 1.29l-1.28 7.08c-.31-.03-.62-.06-.94-.08l.39-7.99s.21-1.74-1.43-1.7c-1.43.04-1.35 1.92-1.35 1.92l-.24 7.55H9.21l.77 2.78s.38-.96 1.47-1.12c.14-.03.29-.04.44-.04h4.72c.4 0 .77.1 1.1.27l.16-.86 1.28-7.55s.13-1.43-1.29-1.56v.01Z'
      />
      <path
        fill='#FFD653'
        d='M10.83 15.11s.34.29 1.06.29h1.82c-.27.2-.51.45-.73.72-.88 1.05-1.44 2.59-1.44 4.3 0 .2.16.36.36.36.2 0 .36-.16.36-.36 0-1.83.69-3.42 1.7-4.3.52-.45 1.14-.72 1.79-.72.51.06.61-.72.09-.72H11.9a1.43 1.43 0 1 1 0-2.86h5.74c.62 0 1.19.43 1.37 1.01l.78 2.57c.07.24.34 1.34.29 1.57 0 3.45-3.37 7.04-7.47 7.04a8.617 8.617 0 0 1-8.6-8.43h.01c.37.33.84.53 1.37.53h.09c.73 0 1.74-.63 1.89-1.3.2-.87.11-3.61.11-3.61l2.65.73s-1.15 1.95.7 3.18Z'
      />
    </svg>
  );
};

export default SvgColoredFingerThree;
